import styled from 'styled-components';

import ZIndexLayers from '../../services/ZIndexLayers';
import { ThemeProp } from '../../theme/Themes';

interface ContainerProps {
  $left?: string;
}

export const Container = styled.div<ContainerProps>`
  position: fixed;
  transform: ${(props: ContainerProps) => `translateX(${props.$left})`};
  transition: all 0.2s ease-in;
  bottom: 1.5rem;
  z-index: ${ZIndexLayers.overModal};
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    left: 0;
    transform: unset;
  }
`;
